var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L12 0L12 12L0 12L0 0Z",
    id: "Background",
    fill: "#59ADFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_photo_size_select_actual",
    transform: "translate(2.5 2.1564941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 7L0 7L0 0L7 0L7 7L7 7Z",
    id: "Bounds",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 0L0.583333 0C0.291667 0 0 0.347222 0 0.694444L0 5.55556C0 5.9375 0.2625 6.25 0.583333 6.25L5.83333 6.25C6.125 6.25 6.41667 5.90278 6.41667 5.55556L6.41667 0.694444C6.41667 0.347222 6.125 0 5.83333 0L5.83333 0ZM1.16669 4.08325L2.18752 2.77075L2.91669 3.64867L3.93752 2.33325L5.25002 4.08325L1.16669 4.08325L1.16669 4.08325Z",
    transform: "translate(0.29174805 0.875)",
    id: "Icon",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.8ec8770154bfd391b428b7ba1fa3be39.svg";
export { ForwardRef as ReactComponent };